var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.805 7.019 1.8 8 2.325 8l-.5 3.013c-.085.508.235.928.727.982l.107.006h8.227c.56 0 .925-.443.834-.988L11.22 8h.557l.973-.973c.19.287.315.618.353.972l.43 4.003c.12 1.104-.678 1.999-1.783 1.999H1.796C.692 14-.108 13.114.012 12.002L.442 8c.039-.356.168-.69.363-.98M7.45.31l3.321 3.653v.508a.99.99 0 0 1-.992.993h-.508l-1.5-2.134v6.634h-2V3.33l-1.5 2.134h-.508a.99.99 0 0 1-.992-.993v-.508L6.094.31a.897.897 0 0 1 1.357 0"
})));
export default SvgCheckOut;